import { useSpotDetailAttachedStateMachine } from './useSpotDetailAttachedStateMachine'
import { useStampFlowStateMachine } from './useStampFlowStateMachine'

type SpotDetailStateMachineOptions = {
  isBarCodeWithGPS: boolean
  isQRCodeWithGPS: boolean
  isKeywordWithGPS: boolean
}

/**
 * スポット詳細ページの統合フック。
 * - useStampFlowStateMachine: スタンプ獲得フロー（メインロジック）
 * - useSpotDetailAttachedStateMachine: 音声ガイド・ARフォトのダイアログ制御
 */
export const useSpotDetailStateMachine = (spotId: number, options: SpotDetailStateMachineOptions) => {
  const stamp = useStampFlowStateMachine(spotId, options)
  const attached = useSpotDetailAttachedStateMachine()

  return {
    stamp,
    attached,
  }
}
